export default __webpack_public_path__ + "static/media/close-1.da54e4e1.svg";